!function() {
  "use strict";
  customElements.get("header-search") || customElements.define("header-search", class extends HTMLElement {
    constructor() {
      super(), this.form = this.querySelector("form"), this.input = this.form.querySelector('input[name="q"]'), 
      this.contentContainer = this.querySelector("[data-content]").cloneNode(!0), this.suggestionsContainer = this.querySelector("[data-suggestions]").cloneNode(!0), 
      this.toggle = this.querySelector("summary"), this.performImmediately = this.performImmediately.bind(this), 
      this.handleToggle = this.handleToggle.bind(this), this.form.addEventListener("reset", (e => setTimeout(this.performImmediately, 0))), 
      this.input.addEventListener("input", (e => this.performDebounce(e))), this.toggle.addEventListener("click", this.handleToggle), 
      this.querySelectorAll("[data-close]").forEach((e => e.addEventListener("click", (() => this.toggle.click())))), 
      this.init();
    }
    perform() {
      let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "header";
      e && (e.preventDefault(), e.stopPropagation());
      const s = encodeURIComponent(this.form.q.value);
      s && fetch(`${window.Shopify.routes.root}search/suggest?q=${s}&resources[type]=product&resources[options][unavailable_products]=last&resources[limit_scope]=each&resources[limit]=3&section_id=${t}`).then((e => e.text())).then((e => {
        const s = (new DOMParser).parseFromString(e, "text/html").querySelector(`#shopify-section-${t}`);
        for (const e of [ "[data-results]", "[data-no-results]", "[data-suggestions]" ]) {
          const t = this.querySelector(e);
          t && (t.innerHTML = s.querySelector(e).innerHTML);
        }
      })).catch((e => {
        console.error(e), this.form.submit();
      }));
    }
    performDebounce() {
      let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "header";
      this.timeout && clearTimeout(this.timeout), "" !== e.target.value.replace(/\s/g, "") ? this.timeout = setTimeout((() => this.perform(e, t)), 200) : this.resetContent();
    }
    performImmediately() {
      let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "header";
      this.timeout && clearTimeout(this.timeout), "" !== this.input.value.replace(/\s/g, "") ? this.perform(e, t) : this.resetContent(), 
      this.form.q.blur();
    }
    handleToggle() {
      if (null !== this.toggle.parentElement.getAttribute("open")) document.body.classList.remove("overflow-clip"); else if (document.body.classList.add("overflow-clip"), 
      window.matchMedia("(max-width: 1024px)").matches) {
        const e = document.querySelector("site-header details");
        e && (e.removeAttribute("open"), e.dispatchEvent(new Event("toggle")));
      }
    }
    resetContent() {
      this.querySelector("[data-content]").innerHTML = this.contentContainer.innerHTML, 
      this.querySelector("[data-suggestions]").innerHTML = this.suggestionsContainer.innerHTML;
      for (const e of this.querySelectorAll("[data-suggestion]")) e.addEventListener("click", (t => {
        t.preventDefault(), this.form.q.value = e.textContent, this.performImmediately(), 
        this.input.focus();
      }));
    }
    init() {
      this.resetContent();
    }
  });
}();